/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the field.
 */
export const CustomFieldType = {
  Text: "text",
  Checkbox: "checkbox",
} as const;
/**
 * The type of the field.
 */
export type CustomFieldType = ClosedEnum<typeof CustomFieldType>;

/** @internal */
export const CustomFieldType$inboundSchema: z.ZodNativeEnum<
  typeof CustomFieldType
> = z.nativeEnum(CustomFieldType);
/** @internal */
export const CustomFieldType$outboundSchema: z.ZodNativeEnum<
  typeof CustomFieldType
> = CustomFieldType$inboundSchema;
